<template>
	<div>
		<v-card
			rounded
			:elevation="flat ? 0 : 10"
			:key="index"
			v-for="({ title, text }, index) in sections"
			class="my-4"
		>
			<v-sheet dark color="#16528E" v-if="title">
				<v-card-text class="font-weight-light text-uppercase">
					<span
						class="display-1 font-weight-light text-uppercase"
						style="opacity: 0.8"
						v-text="title"
					/>
				</v-card-text>
			</v-sheet>

			<v-card-text class="body-1" v-html="text" />
		</v-card>
	</div>
</template>

<script>
export default {
	name: 'InformationSection',
	props: {
		sections: Array,
		noColor: Boolean,
		flat: Boolean,
	},
	computed: {
		color() {
			return this.noColor ? '' : 'primary'
		},
	},
}
</script>